import { Component, OnInit } from '@angular/core';

import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-transports-list',
	templateUrl: './transports-list.component.html',
	styleUrls: ['./transports-list.component.css'],
})
export class TransportsListComponent extends ListComponent {
	protected apiUrl = 'bag/bagTransports';
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'terms', name: 'Terminów' },
		{ id: 'transports', name: 'Transportów' },
	];
}
